module.exports = __webpack_public_path__ + "static/img/industry-yl.8c4532be.png";